import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReceiptTypeCodes } from '@checkout-v2/const';
import { ReceiptService } from '@checkout-v2/feature';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2/models';

@Component({
  selector: 'sd-receipt-type-tabs',
  standalone: true,
  imports: [SdvorIconComponent],
  templateUrl: './receipt-type-tabs.component.html',
  styleUrls: ['./receipt-type-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptTypeTabsComponent {
  private readonly receiptService = inject(ReceiptService);

  readonly receiptTypes = toSignal(this.receiptService.receiptTypes$);
  readonly activeModeId = toSignal(this.receiptService.activeReceiptTypeId$);

  readonly variantIcon: Record<ReceiptTypeCodes, IconTypes> = {
    [ReceiptTypeCodes.Delivery]: IconTypes.CAR,
    [ReceiptTypeCodes.Pickup]: IconTypes.SHOP,
  };

  setActive(code: ReceiptTypeCodes): void {
    this.receiptService.setActiveReceiptType(code);
  }
}
